export { default } from './HoldsUtilityBar';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsUtilityBar/index.js